export const TREAT_POINTS_QUERY_KEY = 'treat-points';
